/*
 * @Author: Chao Yang
 * @Date: 2019-09-29 01:09:45
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-08 10:38:25
 */
export class HeaderMenuItem {
  constructor() {
    this.link = '';
    this.target = '';
    this.text = '';
  }
  public link: string;
  public target: string;
  public text: string;
}
